var common = require("../../../utiles/common.js");
var c = require("../../../utiles/entranceConfig");
var loginUtils = require("../LoginUtils");

require("./concise.less");

module.exports = {
  register: function () {
    document.createElement("login-form");
    ko.components.register("login-form", {
      viewModel: function (params) {
        var $this = this;
        $this.entrance = c.entrance;
        $this.qrcode = ko.observable("");
        $this.tabActive = ko.observable("pwd");
        $this.ioaType = ko.observable("dev");
        $this.ajaxUrl = ko.observable("");
        $this.loginActive = ko.observable("user");
        $this.enabled = ko.observable();
        $this.forgetPasswordEnable = ko.observable(false);
        $this.account = ko.observable({});
        $this.loginEntrance = loginUtils.getLoginEntrance();
        // 如果没有密码相关的就不显示
        $this.isPwdTabs = loginUtils.isPwdTabs($this.loginEntrance);
        if (!$this.isPwdTabs) {
          $this.tabActive("ioa");
        }

        $this.getQR = function () {
          var QRS = [];
          for (var key in $this.loginEntrance) {
            if (key.indexOf("QR") > -1) {
              QRS.push(key);
            }
          }
          return QRS;
        };
        $this.QRS = $this.getQR();
        $this.qrActive = ko.observable($this.QRS[0]);
        $this.loginMethod = ko.observable(
          loginUtils.getPriorityMax($this.loginEntrance, true)
        );
        console.log($this.loginMethod());
        $this.isVerifyCodeVisible = ko.observable(
          common.fetch("/auth/verification/need", {
            type: "GET",
            query: { type: "LOGIN" },
          }).data
        );
        common.fetch("/auth/getLoginAction", {
          type: "GET",
          success: function (result) {
            console.log(result);
            $this.loginAction = result.data;
          },
        });
        //忘记密码判断
        common.fetch("/auth/portal/config/getPortalConfig", {
          type: "GET",
          success: function (result) {
            console.log(result);
            if (result.data) {
              $this.forgetPasswordEnable(
                result.data.forgetPasswordEnable ? true : false
              );
            }
          },
        });
        $this.errorMessage = ko.observable("");
        $this.keypress = function (keyCode) {
          if (keyCode == 13) {
            $this.login();
          }
        };
        $this.userKeypress = function (keyCode) {
          if (keyCode == 13) {
            $("input[type=password]").focus();
          }
        };
        $this.getQrCode = function () {
          return JSON.stringify(
            common.fetch("/auth/qr/login/generateQRCode", {
              type: "GET",
            }).data
          );
        };
        $this.loginBack = function (result, isAD) {
          if (result.data) {
            if (result.data.url) {
              common.redirectTo(result.data.url);
            } else if (result.data.needVerifyCode) {
              $this.isVerifyCodeVisible(true);
              $("img.verifyImg").attr(
                "src",
                "/auth/verification/img?type=LOGIN&random=" + Math.random()
              );
            }
            if (
              result.data.message &&
              result.data.message.replace(/^\s+|\s+$/g, "")
            ) {
              if (isAD) {
                common.message("error", result.data.message);
              } else {
                common.errorAlert(result.data.message);
              }
            }
          } else if (result.message) {
            common.errorAlert(result.message);
          } else {
            common.errorAlert(commonLocal.describe.AbnormalError);
          }
        };
        $this.openCode = function (key) {
          $this.baseUrl = $this.loginEntrance[key].baseUrl;
          $this.url = $this.loginEntrance[key].url;
          $this.qrActive(key);
        };
        if ($this.qrActive()) {
          $this.openCode($this.qrActive());
        }
        $this.login = function () {
          console.log($("body").data("service"));
          var postD = $(".pwdLogin input").serializeObject();
          if (postD.verifyCode == "" && $this.isVerifyCodeVisible()) {
            common.message(
              "error",
              commonLocal.describe.VerificationCodeIsRequired
            );
            return false;
          }
          var service = sessionStorage.getItem("service");
          var callBack = sessionStorage.getItem("callBack")
            ? sessionStorage.getItem("callBack")
            : "";
          if (service) {
            postD.service = service;
          }
          if (callBack) {
            postD.callBack = callBack;
          }
          if (postD.password) {
            var pwdType = { decryptType: "SM2" };
            try {
              pwdType.cryptKey =
                "04" + common.fetch("/auth/flow/login/getSm2PubK").data;
            } catch (error) {}
            console.info("postD.password", pwdType);
            postD.password = common.sm2.doCrypt(
              pwdType.cryptKey,
              postD.password
            );
          }
          var searchUrl = sessionStorage.getItem("searchUrl")
            ? sessionStorage.getItem("searchUrl")
            : "";
          console.log(postD);
          var ajaxUrl =
            $this.loginEntrance[$this.loginMethod()].baseUrl +
            $this.loginEntrance[$this.loginMethod()].url +
            "?" +
            searchUrl;
          common.fetch(ajaxUrl, {
            type: "POST",
            data: JSON.stringify(postD),
            handleError: function (data) {
              $("img.verifyImg").attr(
                "src",
                "/auth/verification/img?type=LOGIN&random=" + Math.random()
              );
            },
            success: function (result) {
              console.log(result);
              $this.loginBack(result);
            },
          });
        };

        $this.ioaClick = function () {
          $this.tabActive("ioa");
          $this.getIOATicket(function (ticket) {
            common.fetch("/auth/ioa/getUserInfo" + "?ticket=" + ticket, {
              type: "GET",
              success: function (result) {
                console.log(result);
                $this.account(result.data);
                $this.ioaType("complete");
                // 如果设置了自动登录就直接调用登录接口
                if ($this.loginEntrance.TICKET.autoLogin) {
                  $this.ioaLogin();
                }
              },
            });
          });
        };

        $this.getIOATicket = function (callback) {
          var script = $this.loginEntrance.TICKET.agentUrl;
          var getUrl = "return getUrl()";
          var url = new Function(script + getUrl)();
          console.log(url);
          $.ajax({
            url: url,
            type: "GET",
            dataType: "json",
            crossDomain: true,
            success: function (result) {
              console.log(result);
              if (result.status === -3) {
                common.errorAlert("快速登录失败，请选择其他登录方式");
              } else {
                callback(result.ticket);
              }
            },
            error: function () {
              $this.ioaType("dev");
            },
          });
        };

        $this.ioaLogin = function () {
          console.log("ioa");
          var loginUrl =
            $this.loginEntrance.TICKET.baseUrl + $this.loginEntrance.TICKET.url;
          $this.getIOATicket(function (ticket) {
            common.fetch(
              loginUrl +
                "?ticket=" +
                ticket +
                "&" +
                window.location.href.split("?")[1],
              {
                type: "GET",
                success: function (result) {
                  console.log(result);
                  $this.loginBack(result);
                },
              }
            );
          });
        };
        if ($this.tabActive() === "ioa") {
          $this.ioaClick();
        }
        //window c端登录
        if ($this.loginEntrance.AD) {
          var anonymous = $this.loginEntrance.AD.autoLogin;
          var spnego = sessionStorage.getItem("spnego");
          $this.enabled(anonymous);
          $this.spnegoLogin = function () {
            $.ajax({
              url: $this.loginEntrance.AD.baseUrl + $this.loginEntrance.AD.url,
              success: function (data) {
                console.log(data);
                common.redirectTo("/#/");
              },
              error: function (result) {
                console.log(result);
                sessionStorage.setItem("spnego", true);
                $this.loginBack(JSON.parse(result.responseText), true);
              },
            });
          };
          if (!spnego && $this.enabled()) {
            $this.spnegoLogin();
          }
        }
      },
      template: require("./LoginForm.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/login/conciseTemplate/ConciseLogin.js
// module id = 108
// module chunks = 0